import request from '@/utils/request'
import { accountPrefix, wisdomsitePrefix } from './config'
import { exportExcel } from '@/utils/download'
export function login(data) {
  return request({
    url: accountPrefix + '/front/auth/loginByPassword',
    method: 'post',
    data
  })
}
export function logout(data) {
  return request({
    url: accountPrefix + '/front/auth/logout',
    method: 'post',
    data
  })
}
export function queryByUser(data) {
  return request({
    url: accountPrefix + '/front/roleResource/queryByUser',
    method: 'post',
    data
  })
}
export function userQueryCurrent(data) {
  return request({
    url: accountPrefix + '/front/user/queryCurrent',
    method: 'post',
    data
  })
}

export function siteProjectQueryByCurrentUser(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectUserRelation/queryByCurrentUser',
    method: 'post',
    data
  })
}
export function listByTypeCode(data) {
  return request({
    url: accountPrefix + '/front/dictionary/listByTypeCode',
    method: 'post',
    data
  })
}
export function regionQueryTree(data) {
  return request({
    url: accountPrefix + '/front/regionInfo/queryTree',
    method: 'post',
    data
  })
}
export function uploadImage(data) {
  return request({
    url: accountPrefix + '/front/file/upload',
    method: 'post',
    onUploadProgress: function (progressEvent) {
      data.processCallBack(progressEvent)
    },
    data: data.data
  })
}
export function uploadIdcardImg(data) {
  return request({
    url: accountPrefix + '/front/file/uploadIdcardImg',
    method: 'post',
    onUploadProgress: function (progressEvent) {
      data.processCallBack(progressEvent)
    },
    data: data.data
  })
}

export function tenementFileTaskList(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementFileTask/pageList',
    method: 'post',
    data
  })
}
export function deleteTenementFileTask(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementFileTask/delete',
    method: 'post',
    data
  })
}

export function queryPersonImportDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementFileTask/queryPersonImportDetail',
    method: 'post',
    data
  })
}

export function downloadTenementFileTask(data) {
  return exportExcel(wisdomsitePrefix + '/front/tenementFileTask/download', data)
}

export function updateUser(data) {
  return request({
    url: accountPrefix + '/front/user/update',
    method: 'post',
    data
  })
}
export function updatePassword(data) {
  return request({
    url: accountPrefix + '/front/user/updatePassword',
    method: 'post',
    data
  })
}
export function tenementHelpMenuTree(data) {
  return request({
    url: accountPrefix + '/front/tenementHelpMenu/tree',
    method: 'post',
    data
  })
}

export function queryTenementHelpMenu(data) {
  return request({
    url: accountPrefix + '/front/tenementHelpMenu/query',
    method: 'post',
    data
  })
}
export function queryByDomain(data) {
  return request({
    url: accountPrefix + '/front/tenementPrivateConfigRecord/queryByDomain',
    method: 'post',
    data
  })
}
export function loginBySecretData(data) {
  return request({
    url: accountPrefix + '/front/auth/loginBySecretData',
    method: 'post',
    data
  })
}
